import './login.scss';

import React from 'react';
import { Translate } from 'react-jhipster';
import { Row, Col } from 'reactstrap';
import { ButtonLounge } from 'app/shared/components/common/button/button-louge';
import { getDocument } from 'app/modules/cms/service/store/selectors';
import { IRootState } from 'app/shared/reducers';
import { useSelector } from 'react-redux';
import { Helmet } from "react-helmet";

export const Login = () => {

  const appStyle: any = useSelector<IRootState>(getDocument('app_global_type'));

  const redirect = () => {
    window.location.href = `/oauth2/authorization/oidc`;
  }

  return (<>
    <Helmet>
      <title>{`${appStyle.data['title'] || 'Assurances SPB - Espace utilisateur'} - Login`}</title>
    </Helmet>
    <Row>
      <Col md="12" style={{ minHeight: 300, padding: 12 }}>
        <h2>
          <Translate contentKey="home.title" interpolate={{ title: appStyle.data['title'] }}>
            Welcome on the {appStyle.data['title']}
          </Translate>
        </h2>
        <ButtonLounge action={() => redirect()} title="Connecter" style={'1 btnRadius'} />
        <br />
      </Col>
    </Row>
  </>
  );
};

